/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IRealtorPropertyPreset {
  currentRentSchedules: any;
  imageTypes: any;
  paymentReminders: any;
  propertyTypes: any;
}

interface ISuccessModalData {
  title: string;
  subtitle: string;
}

interface IProperties {
  realtorPropertyPreset: IRealtorPropertyPreset | null;
  isShowPropertiesModal: boolean;
  activePropertiesModal: 'propertiesPromptModal' | 'propertiesSuccessModal' | '';
  propertiesPromptMode: 'activate' | 'deactivate' | 'delete' | '';
  propertyId: string;
  propertyData: any;
  successModalData: ISuccessModalData;
  refetchRealtorPropertyById: boolean;
}

const initialState: IProperties = {
  realtorPropertyPreset: null,
  isShowPropertiesModal: false,
  activePropertiesModal: '',
  propertiesPromptMode: '',
  propertyId: '',
  propertyData: null,
  successModalData: { title: '', subtitle: '' },
  refetchRealtorPropertyById: false
};

const propertiesSlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    setRealtorPropertyPreset: (
      state: IProperties,
      action: PayloadAction<IRealtorPropertyPreset>
    ) => {
      state.realtorPropertyPreset = action.payload;
    },
    setIsShowPropertiesModal: (state: IProperties, action: PayloadAction<boolean>) => {
      state.isShowPropertiesModal = action.payload;
    },
    setActivePropertiesModal: (
      state: IProperties,
      action: PayloadAction<'propertiesPromptModal' | 'propertiesSuccessModal' | ''>
    ) => {
      state.activePropertiesModal = action.payload;
    },
    setPropertiesPromptMode: (
      state: IProperties,
      action: PayloadAction<'activate' | 'deactivate' | 'delete' | ''>
    ) => {
      state.propertiesPromptMode = action.payload;
    },
    setPropertyId: (state: IProperties, action: PayloadAction<string>) => {
      state.propertyId = action.payload;
    },
    setPropertyData: (state: IProperties, action: PayloadAction<any>) => {
      state.propertyData = action.payload;
    },
    setSuccessModalData: (state: IProperties, action: PayloadAction<ISuccessModalData>) => {
      state.successModalData = action.payload;
    },
    setRefetchRealtorPropertyById: (state: IProperties, action: PayloadAction<boolean>) => {
      state.refetchRealtorPropertyById = action.payload;
    }
  }
});

export const {
  setRealtorPropertyPreset,
  setIsShowPropertiesModal,
  setActivePropertiesModal,
  setPropertiesPromptMode,
  setPropertyId,
  setPropertyData,
  setSuccessModalData,
  setRefetchRealtorPropertyById
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
